import { Icon } from "@iconify/react";
import { Tooltip, IconButton } from "@mui/material";
import { styled, withStyles } from "@mui/styles";
import React from "react";

// const CustomTooltip = withStyles({
//   tooltip: {
//     maxWidth: 150,
//     color: "#000000",
//     background: "#FFFFFF",
//     border: "1px solid #dadde9",
//   },
//   arrow: {
//     color: "#FFFFFF",
//   },
// })(Tooltip);

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))({
  [`& .MuiTooltip-arrow`]: {
    color: "white",
    "&::before": {
      border: "1px solid dadde9",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      backgroundColor: "white",
    },
  },
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid dadde9",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    maxWidth: 250,
  },
});

export default function InfoIconWithCustomTooltip({
  height = "16",
  width = "16",
  toolTipInfo = "Tooltip",
  OnClick = () => {},
}) {
  return (
    <>
      <Tooltip title={toolTipInfo} placement="top">
        <IconButton
          size="small"
          sx={{
            height: height,
            width: width,
            color: "var(--portal-primary-color)", // Set color for the IconButton
          }}
          className="ms-1"
          onClick={OnClick}
        >
          <Icon
            icon="bi:info-circle"
            color="inherit"
            height={height}
            width={width}
          />
        </IconButton>
      </Tooltip>
      {/* <CustomTooltip placement="top" title={toolTipInfo} arrow>
        <Icon
          icon="bi:info-circle"
          className="mx-2"
          color="gray"
          height={height}
          width={width}
        />
      </CustomTooltip> */}
    </>
  );
}
